import { createContext, useContext } from "react";
import { useRouteContext } from "@tanstack/react-router";

const ThemeContext = createContext<{
	theme: "light" | "dark";
}>({
	theme: "light",
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
	const { club } = useRouteContext({ from: "__root__" });

	const _defaultTheme = club.themes?.[0];

	return (
		<ThemeContext.Provider value={{ theme: "light" }}>
			{children}
		</ThemeContext.Provider>
	);
}

export function useTheme() {
	return useContext(ThemeContext);
}
